import { Link } from "react-router-dom";
import { MapPin, Clock, MessageCircle, Mail } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/lib/whatsapp";
import { SERVICES } from "@/data/services";

const Footer = () => (
  <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-12">
      <div>
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="Colors Limpieza" className="h-12 w-12 rounded-full object-cover" />
          <div className="leading-tight">
            <span className="font-display text-lg font-bold text-white">Colors</span>
            <span className="block text-xs font-semibold uppercase tracking-widest text-brand">Limpieza</span>
          </div>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">
          Limpieza profunda a domicilio en Medellín. Cuidado que se ve, confianza que se siente.
        </p>
      </div>

      <div>
        <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-white">Servicios</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/servicios/${s.slug}`} className="transition-colors hover:text-brand" data-testid={`footer-service-${s.slug}-link`}>
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-white">Empresa</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><Link to="/#cobertura" className="transition-colors hover:text-brand" data-testid="footer-cobertura-link">Cobertura</Link></li>
          <li><Link to="/blog" className="transition-colors hover:text-brand" data-testid="footer-blog-link">Blog</Link></li>
          <li><Link to="/#contacto" className="transition-colors hover:text-brand" data-testid="footer-contacto-link">Contacto</Link></li>
          <li><Link to="/#cotizar" className="transition-colors hover:text-brand" data-testid="footer-quote-link">Cotizar servicio</Link></li>
        </ul>
      </div>

      <div>
        <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-white">Contacto</h3>
        <ul className="mt-4 space-y-3 text-sm">
          <li className="flex items-start gap-2.5">
            <MapPin size={16} className="mt-0.5 shrink-0 text-brand" />
            Medellín y Valle de Aburrá, Colombia
          </li>
          <li className="flex items-start gap-2.5">
            <Clock size={16} className="mt-0.5 shrink-0 text-brand" />
            Lun a Sáb: 7:00 am - 6:00 pm
          </li>
          <li>
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 transition-colors hover:text-[#25D366]"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle size={16} className="shrink-0 text-[#25D366]" />
              +57 300 123 4567
            </a>
          </li>
          <li className="flex items-center gap-2.5">
            <Mail size={16} className="shrink-0 text-brand" />
            hola@colorslimpieza.co
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} Colors Limpieza · Medellín, Colombia. Todos los derechos reservados.
    </div>
  </footer>
);

export default Footer;
